/**
 * Synchronous pilot signal emitted from root layout when the server enables EH consent Tealium.
 * Client code reads this before React hydrates feature flags (ADR-014), so legacy Tealium does not
 * load ahead of `PageProviderClient` initFeatureFlags.
 */
export const EH_CONSENT_TEALIUM_PILOT_WINDOW_KEY = '__ACX_EH_CONSENT_TEALIUM_PILOT__'

export const EH_CONSENT_TEALIUM_PILOT_INLINE_SCRIPT = `(function(){window["${EH_CONSENT_TEALIUM_PILOT_WINDOW_KEY}"]=true;})();`

export function isEhConsentTealiumPilotSeededInWindow(): boolean {
  if (typeof window === 'undefined') return false
  return (
    (window as unknown as Record<string, unknown>)[EH_CONSENT_TEALIUM_PILOT_WINDOW_KEY] === true
  )
}
